<template>
  <!-- 在homeTop添加消息组件,使用WebSocket的方式  -->
  <common-home-top>
    <template #left>
      <!-- 通知公告 -->
      <div class="system-message">
        <board-simple-overflow :data-list="messageList" :speed=".05">
          <template v-slot="{data}">
            <div class="message-item" @click="router.push(`/sys/message/view?id=${data.id}`)" :style="{'color': `${messageTextColor(data.messageLevel)}`}">{{data.messageTitle}}</div>
          </template>
        </board-simple-overflow>
      </div>
      <slot/>
    </template>
    <template #right>
      <!-- 接收到的消息提醒,使用消息组件 -->
      <common-system-notice-component :notice-count="messageNotRead" :query-notice-list="queryNoticeList"
                                      :query-notice-type-count="queryNoticeTypeCount" :read-notice="readNotice"/>
    </template>
  </common-home-top>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import CommonHomeTop from "@/views/h5/common/home/components/top/CommonHomeTop.vue";
import BoardSimpleOverflow from "@/components/h5/board/BoardSimpleOverflow.vue";
import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import CommonSystemNoticeComponent from "@/views/h5/common/home/components/top/CommonSystemNoticeComponent.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    TableButton, YqIcon, CommonHomeTop, BoardSimpleOverflow, FormItems, FormItem, CommonSystemNoticeComponent
  },
  data() {
    return {
      userInfo: {},
      messageList: [],
      messageNotRead: 0,
      messageSession: null,
      receiveNoticeListCallBack: null, // 查询到提醒消息后回调
      receiveNoticeTypeCountCallBack: null, // 查询到未读分类统计后回调
    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.userInfo = user;
      this.createWebSocket();
    })
  },
  unmounted() {
    // 离开页面时清空轮询
    if (this.messageSession) {
      console.log("关闭WS")
      this.messageSession.close();
    }
  },
  methods: {
    // 心跳包发送
    heartbeat() {
      if (this.messageSession) {
        let cmd = {cmd: "ping"}
        this.wsSend(JSON.stringify(cmd));
      }
    },
    createWebSocket() {
      console.log("开始创建WS")
      this.messageSession = new WebSocket(process.env.VUE_APP_WS_URL + "/basedata/ws/message");
      this.messageSession.onopen = this.wsOpen;
      this.messageSession.onmessage = this.wsMessage;
      this.messageSession.onerror = this.wsError;
      this.messageSession.onclose = this.wsClose;
    },
    wsOpen() {
      console.log("远程连接已建立，开始申报用户信息")
      let json = {
        cmd: "declare",
        userId: this.userInfo.id,
      }
      this.wsSend(JSON.stringify(json));
    },
    wsSend(message) {
      if (!this.messageSession || this.messageSession.readyState === 2 || this.messageSession.readyState === 3) {
        // 重新连接
        this.createWebSocket();
        return;
      }
      this.messageSession.send(message);
    },

    wsMessage(e) {
      let data = e.data;
      if (!data.startsWith("{")) {
        console.log("服务器返回未知消息");
        console.log(data);
        return;
      }
      let json = JSON.parse(data);
      switch (json.cmd) {
        case "registerSuccess": // 注册成功，也就是declare成功
          let param = {
            merchantId: this.userInfo.merchantId,
            userId: this.userInfo.id,
            departCode: this.userInfo.mainDepartCode,
            pageNumber: 1,
            category: "PROCLAMATION",
            pageSize: 10,};
          this.wsSend(JSON.stringify({cmd: "noticeCount", ...param})); // 向后台请求，未读消息条数
          this.wsSend(JSON.stringify({cmd: "messageList", ...param}));// 向后台请求，消息列表
          break;
        case "receiveNotice": // 接收到新的提醒消息
          this.$message.info("您有新的消息，请注意查收");
          // 当接收到消息时，马上进行查询，由于数据库插入的时间差，无法正常查询到数据
          setTimeout(() => {
            this.queryNoticeCount();
          }, 500);
          break;
        case "noticeCount": // 后台返回未读消息数
          this.messageNotRead = json.data;
          break;
        case "noticeList": // 后台返回提醒消息列表
          if (this.receiveNoticeListCallBack) { // 使用回调进行返回
            // 这个data的time是时间戳，需要转换成日期格式
            let pageInfo = json.data;
            pageInfo.records.forEach(item => {
              item.messageTime = new Date(item.messageTime).format("yyyy-MM-dd hh:mm:ss");
            });
            this.receiveNoticeListCallBack(pageInfo);
            this.receiveNoticeListCallBack = null;
          }
          break;
        case "noticeTypeCount": // 后台返回未读消息的分类统计
          if (this.receiveNoticeTypeCountCallBack) {
            this.receiveNoticeTypeCountCallBack(json.data);
            this.receiveNoticeTypeCountCallBack = null;
          }
          break;
        case "messageProclamationList": // 后台返回消息列表
          this.messageList = json.data;
          break;
        case "pong":
          console.log("服务器返回心跳包")
          break;
      }
    },
    queryNoticeCount() {
      let param2 = {
        cmd: "noticeCount",
        merchantId: this.userInfo.merchantId,
        userId: this.userInfo.id,
        departCode: this.userInfo.mainDepartCode,
        pageNumber: 1,
        pageSize: 10,};
      this.wsSend(JSON.stringify(param2)); // 刷新未读消息数
    },
    wsError(e) {
      console.log("远程连接已断开", e)
    },
    wsClose(e) {
      console.log("远程连接已断开", e)
    },
    // 搜索消息列表
    queryNoticeList(searchInfo) {
      return new Promise(resolve => {
        this.receiveNoticeListCallBack = resolve;
        this.wsSend(JSON.stringify({
          ...searchInfo,
          merchantId: this.userInfo.merchantId,
          employeeId: this.userInfo.id,
          cmd: "noticeList",
        }));
      });
    },
    // 未读消息的分类统计，与消息列表同一条 WS 通道
    queryNoticeTypeCount() {
      return new Promise(resolve => {
        this.receiveNoticeTypeCountCallBack = resolve;
        this.wsSend(JSON.stringify({
          cmd: "noticeTypeCount",
          merchantId: this.userInfo.merchantId,
          userId: this.userInfo.id,
        }));
      });
    },
    // 公告的字体颜色，按照等级区分
    messageTextColor(level) {
      switch ( level) {
        case 1:
          return "var(--el-color-primary)";
        case 2:
          return "var(--el-color-warning)";
        case 3:
          return "var(--el-color-danger)";
        default:
          return "var(--yq-font-color-base)";
      }
    },
    // 读取消息，不需要回调
    readNotice(deviceType, ids) {
      this.messageNotRead -= ids.length;
      this.wsSend(JSON.stringify({cmd: "readNotice", data: ids, deviceType}));
    }
  }
};
</script>

<style lang="scss" scoped>
.system-message{
  width: 300px;
  height: 20px;
  margin-right: 20px;
  .message-item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    cursor: pointer;
    text-align: right;
  }
}

</style>